<template lang="pug">
v-container
  .text-center(v-if="isLoading")
    v-progress-circular.mt-8(width="2" size="50" color="primary" indeterminate)
  template(v-else)
    template(v-if="segment")
      v-row.mt-sm-8(no-gutters)
        v-col(cols="12" md="6")
          .d-flex.align-center
            template(v-if="isEditingTitle")
              v-form(ref="form" @submit.prevent)
                yc-text-field.mr-2(
                  label="Segment name"
                  v-model="editedName"
                  :rules="rules.not_empty"
                  validate-on-blur
                )
              v-btn.button-md.mr-2(@click="saveEdit" :loading="isSaving" color="info" depressed) {{ $t('save') }}  
              v-btn.button-md(@click="isEditingTitle = false" color="primary400" text) {{ $t('cancel') }}
            template(v-else)
              .text-2xl.font-semibold.mr-2 {{ segment.title }}
              v-btn(@click="editSegmentName" color="primary400" icon)
                v-icon(small) $yzi-edit-02
          div
            template(v-if="isEditingDescription")
              yc-text-field.mr-2.mb-2(:label="$t('description')" v-model="editedDescription")
              v-btn.button-md.mr-2(
                @click="saveEditDescription"
                :loading="isSavingDescription"
                color="info"
                depressed
              ) {{ $t('save') }} 
              v-btn.button-md(
                @click="isEditingDescription = false"
                color="primary400"
                text
              ) {{ $t('cancel') }}
            template(v-else)
              .text-sm.primary400--text {{ segment.description || 'No description' }}
                span
                  v-btn(@click="editSegmentDescription" color="primary400" icon)
                    v-icon(small) $yzi-edit-02
        v-col.d-flex(cols="12" md="6")
          v-spacer
          v-btn.button-sm.mr-2(color="primary" outlined @click="blastSmsToAll")
            v-icon(left color="primary") $yzi-message-circle-01
            | {{ $t('blast_sms') }}
          v-btn.button-sm.mr-2(color="primary" outlined @click="blastEmailToAll")
            v-icon(left color="primary") $yzi-mail-01
            | {{ $t('blast_email') }}
          v-menu(offset-y)
            template(v-slot:activator="{ on, attrs }")
              v-btn.button-sm(
                v-bind="attrs"
                v-on="on"
                color="info500"
                depressed
                dark
              ) 
                v-icon.mr-2.ml-n1(small) $yzi-chevron-down
                span {{ $t('add_people') }}
            v-list
              v-list-item(v-for="(item, index) in addOptions" :key="index" @click="openAddPage(item)")
                .text-sm {{ item.title }}
          v-menu(offset-y)
            template(v-slot:activator="{ on, attrs }")
              v-btn.ml-2.mt-1(v-on="on" color="neutral500" icon)
                v-icon mdi-dots-horizontal
            v-list
              v-list-item(@click="showDeleteDialog = true")
                .text-sm.danger500--text {{ $t('delete_segment') }}
      .my-6
        v-row(no-gutters)
          v-col(cols="12")
            v-tabs.segment-tabs(v-model="tabPosition" height=40)
              v-tab.text-md.font-medium.text-capitalize {{ $t('customers') }}
              v-tab.text-md.font-medium.text-capitalize {{ $t('sms_blast_report') }}
              v-tab.text-md.font-medium.text-capitalize {{ $t('email_blast_report') }}
        v-divider
      v-tabs-items(v-model="tabPosition" touchless)
        v-tab-item
          customer-list(isGroupMode :segment="segment")
        v-tab-item
          sms-blast-report(:group="id")
        v-tab-item
          email-blast-report(:group="id")
    template(v-else)
      .primary400--text Data not found
    delete-segment-dialog(
      v-if="showDeleteDialog" 
      :open.sync="showDeleteDialog" 
      :segments="[segment]" 
      @deleted="onDeleted"
    )
    delete-customer-segment-dialog(
      v-if="showDeleteCustomerDialog"
      :open.sync="showDeleteCustomerDialog" 
      :customers="selectedCustomers"
      :segment="segment"
      @deleted="onDeleteCustomer"
    )
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import DeleteSegmentDialog from '@/components/module/segment/DeleteSegmentDialog.vue'
import DeleteCustomerSegmentDialog from '@/components/connect/dialogs/DeleteCustomerSegmentDialog.vue'
import SmsBlastReport from '@/components/donation/segments/SmsBlastReport.vue'
import EmailBlastReport from '@/components/donation/segments/EmailBlastReport.vue'
import CustomerList from '../customers/CustomerList.vue'

export default {
  props: ['id'],
  components: { DeleteSegmentDialog, DeleteCustomerSegmentDialog, SmsBlastReport, EmailBlastReport, CustomerList },
  data: () => ({
    segment: null,
    isEditingTitle: false,
    isEditingDescription: false,
    isLoading: true,
    isSaving: false,
    isSavingDescription: false,
    editedName: '',
    editedDescription: '',
    showDeleteDialog: false,
    showAddDrawer: false,
    showDeleteCustomerDialog: false,
    rules: {
      not_empty: [v => v.trim().length || 'This field is required']
    },
    customers: [],
    defaultCustomers: [],
    selectedCustomers: [],
    headers: [
      {
        text: '',
        value: 'checked'
      },
      {
        text: 'Name',
        value: 'name'
      },
      {
        text: 'Phone number',
        value: 'phone'
      }
    ],
    searchText: '',
    addOptions: [
      {
        id: 'customer',
        title: 'Select from customer list'
      }
    ],
    checkAll: false,
    tabPosition: 0
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  created() {
    this.headers.map(item => item['class'] = 'text-table-header')
    this.fetchSegment()
  },  
  methods: {
    ...mapActions(['showMessage']),
    fetchSegment() {
      this.isLoading = true
      this.$axios.get(`/connect/${this.company.slug}/groups/${this.id}`)
      .then(resp => {
        this.segment = resp.data
        this.customers = resp.data.customer
        this.defaultCustomers = resp.data.customer
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    editSegmentName() {
      this.isEditingTitle = true
      this.editedName = this.segment.title
    },
    editSegmentDescription() {
      this.isEditingDescription = true
      this.editedDescription = this.segment.description
    },
    saveEdit() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isSaving = true
      const params = {
        title: this.editedName.trim(),
      }
      this.$axios.patch(`/connect/${this.company.slug}/groups/${this.id}`, params)
      .then(resp => {
        this.isEditingTitle = false
        this.showMessage(['success', this.$t('success_message.segment_title_changed_successfully')])
        this.segment = resp.data
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_change_segment_title')])
      })
      .finally(() => {
        this.isSaving = false
      })
    },
    saveEditDescription() {
      this.isSavingDescription = true
      const params = {
        description: this.editedDescription
      }
      this.$axios.patch(`/connect/${this.company.slug}/groups/${this.id}`, params)
      .then(resp => {
        this.isEditingDescription = false
        this.showMessage(['success', this.$t('success_message.segment_description_changed_successfully')])
        this.segment = resp.data
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_change_segment_description')])
      })
      .finally(() => {
        this.isSavingDescription = false
      })
    },
    queryChange: debounce(function (query) {
      this.customers = this.defaultCustomers.filter(item => {
        const { id, name, phone } = item
        return id.toString().includes(query) || name.toLowerCase().includes(query) || phone.toLowerCase().includes(query)
      })
    }, 750),
    openAddPage(item) {
      switch (item.id) {
        case 'customer':
          this.$router.push(`/admin/connect/segments/${this.segment.id}/add-customers`)
          break
      }
    },
    onDeleted() {
      this.$router.push('/admin/connect/segments')
    },
    onDeleteCustomer() {
      this.fetchSegment()
    },
    onCheckedAll() {
      const clone = [...this.customers]
      clone.map(item => item.checked = this.checkAll)
      this.customers = [...clone]
      this.selectedCustomers = this.customers.filter(item => item.checked === true)
    },
    onChecked() {
      this.selectedCustomers = this.customers.filter(item => item.checked === true)
      this.selectedCustomers = [...this.selectedCustomers]
      this.checkAll = false
    },
    clearSelection() {
      this.checkAll = false
      this.onCheckedAll()
    },
    deleteCustomers() {
      this.showDeleteCustomerDialog = true
    },
    blastSmsToAll () {
      this.$router.push(`/admin/connect/segments/${this.id}/send-message`)
    },
    blastEmailToAll () {
      this.$router.push(`/admin/connect/segments/${this.id}/send-email`)
    }
  }
}
</script>

<style lang="scss">
.segment-tabs {
  .v-tabs-slider-wrapper {
    height: 6px !important;
    bottom: -3px !important;
  }

  .v-tabs-slider {
    border-radius: 3px !important;
  }
}
</style>